var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCard5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 39,
    height: 39,
    fill: "#E2DEFF",
    stroke: "#4A03A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2991 21.1306C25.5791 22.2306 25.0891 23.2506 24.2491 23.7706V25.7505C24.2491 26.4405 23.6891 27.0005 22.9991 27.0005C22.3091 27.0005 21.7491 26.4405 21.7491 25.7505V23.7706C21.0691 23.3506 20.6191 22.6005 20.6191 21.7505C20.6191 20.2305 22.0591 19.0505 23.6391 19.4705C24.4391 19.6805 25.0891 20.3306 25.2991 21.1306Z",
    fill: "#4A03A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 33.75C17.07 33.75 12.25 28.93 12.25 23C12.25 17.07 17.07 12.25 23 12.25C27.74 12.25 31.86 15.29 33.27 19.8C33.39 20.2 33.17 20.62 32.78 20.74C32.38 20.86 31.96 20.64 31.84 20.25C30.63 16.36 27.08 13.75 23.01 13.75C17.91 13.75 13.76 17.9 13.76 23C13.76 28.1 17.91 32.25 23.01 32.25C27.07 32.25 30.62 29.65 31.83 25.78C31.95 25.38 32.37 25.17 32.77 25.29C33.17 25.41 33.38 25.84 33.26 26.23C31.84 30.73 27.72 33.75 23 33.75Z",
    fill: "#4A03A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCard5);
export default __webpack_public_path__ + "static/media/benefit-card-5.8035e7eb991af4120901328a6375fdfc.svg";
export { ForwardRef as ReactComponent };